module.exports = __webpack_public_path__ + "img/5th-Wheel-Desktop.dffddd69.jpg";